
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/study-groups",
      function () {
        return require("private-next-pages/community/study-groups/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/study-groups"])
      });
    }
  